var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{class:[
    'separator',
    { 'separator--line': _vm.hasLine },
    ( _obj = {}, _obj[("separator--" + _vm.size)] = !!_vm.size, _obj ) ]})}
var staticRenderFns = []

export { render, staticRenderFns }